var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.369,
    height: 13.338,
    viewBox: "0 0 13.369 13.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.114,3.94a3.666,3.666,0,0,0,.573,5.533.152.152,0,0,0,.19-.018,6.084,6.084,0,0,0,.983-1.188.143.143,0,0,0-.056-.2,1.835,1.835,0,0,1-.7-.724h0a1.765,1.765,0,0,1-.15-1.206h0a3.906,3.906,0,0,1,1.145-1.521h0l1.675-1.709a1.718,1.718,0,0,1,2.439-.012,1.739,1.739,0,0,1,.025,2.452l-1.014,1.043a.178.178,0,0,0-.04.182,4.8,4.8,0,0,1,.134,2.354.021.021,0,0,0,.035.019l2.159-2.2a3.619,3.619,0,1,0-5.17-5.066l-2.212,2.258-.009.009Z",
    transform: "translate(-147.162 0)",
    fill: "#214277"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.988,175.522h0l0,0a3.7,3.7,0,0,0,.321-2.63h0A3.634,3.634,0,0,0,7.846,170.8a.2.2,0,0,0-.222.01,3.513,3.513,0,0,0-.971,1.173.163.163,0,0,0,.065.212,1.816,1.816,0,0,1,.7.71h0A1.663,1.663,0,0,1,7.589,174h0c-.078.6-.681,1.146-1.161,1.64h0l-1.666,1.7a1.734,1.734,0,0,1-2.477-2.427L3.3,173.865a.178.178,0,0,0,.041-.179,5.059,5.059,0,0,1-.145-2.347.021.021,0,0,0-.035-.018l-2.126,2.17a3.675,3.675,0,0,0,.026,5.145,3.63,3.63,0,0,0,5.118-.052,26.969,26.969,0,0,0,2.806-3.061Z",
    transform: "translate(0 -165.739)",
    fill: "#214277"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrl);
export default __webpack_public_path__ + "static/media/url.b66eebc557d8dbab004b2e33a5aa399f.svg";
export { ForwardRef as ReactComponent };